import {useWindowDimensions} from 'react-native';
import {breakpointPhone, breakpointDesktop} from '../../../style/adminTools';

const useLayoutTier = () => {
  const {width} = useWindowDimensions();
  if (width < breakpointPhone) return 'mobile';
  if (width >= breakpointDesktop) return 'wide';
  return 'tablet';
};

export default useLayoutTier;
